import React, { useCallback, useMemo, useRef } from 'react'
import { Grid } from '@material-ui/core'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import SydButton from '../../../commonDesign/Button'
import FlexRow from '../../../molecules/FlexRow'
import FlexActions from '../../../molecules/FlexActions'
import OperationalTable from '../../../organisms/OperationalTable'
import { useListScheduleTargetsAdmin } from '../../../../api/scheduler'
import ScanDialog from './ScanDialog'
import { extractResourceName } from './utils'

const columns = [
  { id: 'displayName', accessor: 'displayName', Header: 'Target' },
  { id: 'code', accessor: 'code', Header: 'Code' },
  { id: 'domain', accessor: 'domain', Header: 'Domain' },
  { id: 'commandName', accessor: 'commandName', Header: 'Command' },
  { id: 'lambdaTargetDisplayName', accessor: 'lambdaTargetDisplayName', Header: 'Lambda' },
  {
    id: 'lambdaTargetArn',
    accessor: 'lambdaTargetArn',
    Header: 'ARN',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => {
      if (!value) return <span style={{ color: '#999' }}>Not resolved</span>
      return <span title={value}>{extractResourceName(value)}</span>
    }
  },
  {
    id: 'enabled',
    accessor: 'effectiveEnabled',
    Header: 'Enabled',
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) => value ? 'Yes' : 'No'
  }
]

function flattenTargetGroups (groups) {
  const rows = []
  for (const group of groups) {
    for (const ct of group.commandTargets) {
      rows.push({
        ...ct,
        lambdaTargetCode: group.lambdaTargetCode,
        lambdaTargetDisplayName: group.lambdaTargetDisplayName,
        lambdaTargetArn: group.lambdaTargetArn,
        lambdaTargetEnabled: group.lambdaTargetEnabled,
        effectiveEnabled: ct.enabled && group.lambdaTargetEnabled
      })
    }
  }
  return rows
}

function TargetListing () {
  const { data: targetGroups, isLoading } = useListScheduleTargetsAdmin()
  const scanRef = useRef(null)

  const rows = useMemo(() =>
    targetGroups ? flattenTargetGroups(targetGroups) : [],
  [targetGroups])

  const handleScan = useCallback(() => {
    scanRef.current?.run()
  }, [])

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FlexRow style={{ width: '100%' }}>
            <h2 style={{ margin: 0 }}>Targets</h2>
            <FlexActions style={{ flex: 1 }}>
              <SydButton
                size='sm'
                variant='outline'
                icon='refresh'
                onClick={handleScan}
              >
                Scan ARNs
              </SydButton>
            </FlexActions>
          </FlexRow>
        </Grid>
        <Grid item xs={12}>
          {!rows.length ? (
            <EmptySection
              title='No Targets'
              description='No schedule targets have been configured yet.'
            />
          ) : (
            <OperationalTable
              variant='v2'
              columns={columns}
              data={rows}
              defaultSort={[{ id: 'displayName', desc: false }]}
            />
          )}
        </Grid>
      </Grid>

      <ScanDialog ref={scanRef} />
    </>
  )
}

export default TargetListing
